import { TenantEnum } from '@jsmdg/tenancy';
import { jsCategories, mdCategories } from '../__fixtures__/categoryItems';
import { type TenantConfig } from '../shared/types/tenantConfig';

const jsDeTenantConfig: TenantConfig = {
    allExperiencesLabel: 'Alle Erlebnisse entdecken',
    allExperiencesPath: '/l/79ifa',
    category: 'Erlebniskategorien',
    displayJudgement: 'urteilsveroeffentlichung',
    onlineExperienceOptions: ['Landesweit', 'Weltweit'],
    organisationAddress: {
        '@type': 'PostalAddress',
        streetAddress: 'Mühldorfstraße 8',
        postalCode: '81671',
        addressLocality: 'München',
        addressCountry: 'Deutschland',
    },
    organisationAvailableLanguages: [
        {
            '@type': 'Language',
            name: 'German',
            alternateName: 'de',
        },
        {
            '@type': 'Language',
            name: 'English',
            alternateName: 'en',
        },
    ],
    organisationFounder: {
        '@type': 'Person',
        name: 'Jochen Schweizer',
        sameAs: 'https://www.instagram.com/jochenschweizer/',
    },
    organisationName: 'Jochen Schweizer GmbH',
    uspClaim: 'Jeder Gutschein für 9.000 Erlebnisse einlösbar',
    uspValidityText: 'Gutscheine 3 Jahre gültig und verlängerbar',
    categoryItems: jsCategories,
    partnerPortalUrl: 'https://partner.jsmd-group.com/',
};

const jsAtTenantConfig = {
    ...jsDeTenantConfig,
    uspValidityText: 'Gutscheine 10 Jahre gültig und verlängerbar',
};

const mdDeTenantConfig = {
    ...jsDeTenantConfig,
    organisationName: 'mydays GmbH',
    allExperiencesPath: '/l/o7trc',
    categoryItems: mdCategories,
};

const mdAtChTenantConfig = {
    ...mdDeTenantConfig,
    uspValidityText: 'Gutscheine 10 Jahre gültig und verlängerbar',
};

const tenantConfigMap: Record<TenantEnum, TenantConfig> = {
    [TenantEnum.JS_DE]: jsDeTenantConfig,
    [TenantEnum.JS_AT]: jsAtTenantConfig,
    [TenantEnum.MD_DE]: mdDeTenantConfig,
    [TenantEnum.MD_AT]: mdAtChTenantConfig,
    [TenantEnum.MD_CH]: mdAtChTenantConfig,
    [TenantEnum.JS_NOW_DE]: jsDeTenantConfig,
    [TenantEnum.JS_TEST]: jsDeTenantConfig,
    [TenantEnum.MD_TEST]: { ...jsDeTenantConfig, categoryItems: mdCategories },
};

const getTenantConfig = (tenant: TenantEnum): TenantConfig => {
    return tenantConfigMap[tenant] || tenantConfigMap[TenantEnum.JS_DE];
};

export { getTenantConfig };
